import { useEffect } from "react";

import { useUserContext } from "../contexts/UserProvider";
import { useResource } from "../../services";
import { UserType } from "../../types/context";
import { createResourceUrl } from "../data";

export const useProfileData = () => {
  const { setUser } = useUserContext();
  const userid = localStorage.getItem("userid");
  const { data: userData } = useResource<UserType[]>(
    createResourceUrl("/common/user", {
      include: [
        "latest_agreement_file",
        "latest_gdpr_file",
        "participant_agents",
        "participant_agents.agent",
        "participant_agents.participant_status",
        "participant_agents.agent.preferred_agreement_template",
        "participant_agents.latest_accepted_agreement",
      ],
      filters: {
        "eq:id": userid,
      },
    }),
    !!userid,
  );

  useEffect(() => {
    if (userData?.[0]) {
      setUser(userData?.[0]);
    }
  }, [userData]);
};
